import PropTypes from 'prop-types';
import React, { PureComponent, Fragment } from 'react';
import styled from 'styled-components';
import { withNamespaces } from 'react-i18next';
import { DesktopOnly } from '../MediaTargets';
import { Tabs } from './Tabs';
import { Tab } from './Tab';
import { UserAccount } from '../../../userAccount';
import { HEADER_HEIGHT, HEADER_FULLSCREEN_HEIGHT } from '../../../base/constants';
import { LeftSection } from './LeftSection';

const RightSection = styled.div`
  float: right;
  overflow: hidden;
  :after {
    content: '';
    clear: both;
    display: table;
  }
`;

const Wrapper = styled.header`
  color: #a8a8a8;
  flex: 0 1 0;
  font-family: 'Pluto Sans SemiBold', sans-serif;
  font-size: 18px;
  width: 100%;
  height: ${({ isFullscreen, isMobile }) =>
    isFullscreen && !isMobile ? HEADER_FULLSCREEN_HEIGHT : HEADER_HEIGHT}px;
  z-index: 30;
  @media (max-width: 960px) and (orientation: landscape) {
    display: ${({ isMobile }) => (isMobile ? 'none' : '')};
  }
`;

class HeaderComponent extends PureComponent {
  static propTypes = {
    page: PropTypes.string.isRequired,
    displayTabsAndUserAccount: PropTypes.bool.isRequired,
    enableVOD: PropTypes.bool.isRequired,
    redirectToWatch: PropTypes.func.isRequired,
    redirectToVod: PropTypes.func.isRequired,
    redirectToTrending: PropTypes.func.isRequired,
    trendingVisible: PropTypes.bool.isRequired,
    isFullscreen: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
    isUserAccountEnabled: PropTypes.bool.isRequired,
  };

  render() {
    const {
      redirectToWatch,
      redirectToVod,
      redirectToTrending,
      page,
      displayTabsAndUserAccount,
      trendingVisible,
      enableVOD,
      t,
      isFullscreen,
      isMobile,
      isUserAccountEnabled,
    } = this.props;

    return (
      <Wrapper isFullscreen={isFullscreen} isMobile={isMobile}>
        <LeftSection />
        {displayTabsAndUserAccount && (
          <Fragment>
            {isUserAccountEnabled && (
              <RightSection>
                <UserAccount />
              </RightSection>
            )}
            <DesktopOnly>
              <Tabs {...this.props} value={page}>
                <Tab onClick={redirectToWatch} value="Watch">
                  {t('live_tv')}
                </Tab>
                {enableVOD && (
                  <Tab onClick={redirectToVod} value="Vod">
                    {t('on_demand')}
                  </Tab>
                )}
                {trendingVisible && (
                  <Tab onClick={redirectToTrending} value="Trending">
                    {t('trending')}
                  </Tab>
                )}
              </Tabs>
            </DesktopOnly>
          </Fragment>
        )}
      </Wrapper>
    );
  }
}

HeaderComponent = withNamespaces()(HeaderComponent);
export { HeaderComponent };
